import { PACKAGES } from "../constants/types";

export default function (state = [], action) {
  switch (action.type) {
    case PACKAGES:
      return action.payload;
    default:
      return state;
  }
}
